// Billing codes for claim lines, resolved through the Service Catalog.
//
// A visit from the unified feed is either an AxisCare visit (service.code is
// AxisCare's label, e.g. "RN - Skilled" or an older alias) or a CAERA visit
// (service.id is the catalog line). Either way the claim line gets the
// catalog's procedure code and modifier, the human label goes to
// service_label, and the source is recorded so a run can be traced back.
import { supabase } from './supabase';

let cache = { at: 0, rows: [] };

export const loadBillingCatalog = async () => {
  if (Date.now() - cache.at < 60_000 && cache.rows.length) return cache.rows;
  const { data, error } = await supabase.from('service_catalog')
    .select('id, code, name, procedure_code, modifier1, modifier2, modifier3, axiscare_service_code, axiscare_service_aliases, unit_basis, active');
  if (error) throw new Error(error.message);
  cache = { at: Date.now(), rows: data || [] };
  return cache.rows;
};

// The lookup itself lives in billingCodeRules.js, which has no Supabase import,
// so the Monday billing run applies exactly this rule through _shared/lib.
export { billingCodeFor, visitRef, findCatalogLine } from './billingCodeRules.js';
